import { SidebarAd } from '@/Shared/SidebarAd'
import { MagicDownloadsLinks } from '@/Shared/MagicDownloadsLinks'
import { MagicShopLinks } from '@/Shared/MagicShopLinks'

type DefaultSidebarProps = {
  showAdvertisement?: boolean;
}

export const DefaultSidebar = ({ showAdvertisement = true }: DefaultSidebarProps) => (
  <div className="hidden lg:flex flex-col gap-y-4 max-w-xs w-80 mr-10 shrink-0">
    {showAdvertisement && <SidebarAd />}
    <MagicDownloadsLinks />
    <MagicShopLinks />
  </div>
)